import React, { Component, useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import Modal from "react-modal";
import axios from "axios";
import config from "@config";
import { Link, withRouter } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Select from "react-select";
import utilityFunctions from "@store/utilityFunctions";
import errorFunctions from "@store/errorFunctions";
import StaffAdd from "./StaffAdd";
import StaffEdit from "./StaffEdit";
import "../common.css";
import LoadingPage from "@components/Loading/Loading";
import { TablePagination } from "@material-ui/core";
import SelectOption from "@components/Select/SelectOption";
import apiEndpoints from "@store/apiEndpoints";

class Staffs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddUser: false,
      showStaffAdd: false,
      showStaffEdit: false,
      showResetPwd: false,
      showVerifyAccount: false,
      employeeID: "",
      typePassword: true,
      selectedUser: null,
      showConfirmDelete: false,
      showConfirmApprove: false,
      sellerOptions: [],
      locationOptions: [],
      selectedSeller: {},
      selectedLocation: {},
      storeLocationId: 0,
      data: [],
      filteredStaffs: [],
      searchFilter: "",
      loading: false,
      isLoading: false,
      storeValue: null,
      pageNumber: 1,
      rowPerPage: 10,
    };
  }

  // Same condition componentDidMount uses to pick the staff-vs-employee
  // endpoint, so pagination/search/updates don't fall back to the general
  // employee list for a Commercial Staff/Admin viewing their own staff tab.
  isCommercialUser = () =>
    !this.props.isCin7 &&
    !this.props.isApproval &&
    this.props.userInfo.user.role.includes("Commercial");

  handleDropDownAssignTo = (e) => {
    this.setState({ employeeID: e.target.value });
  };

  handleClickDelete = (item) => {
    this.setState({ selectedUser: item, showConfirmDelete: true });
  };

  handleClickDecline = (item) => {
    this.setState({
      selectedUser: item,
      showConfirmDecline: true,
    });
  };

  handleClickApprove = (item) => {
    this.setState({
      selectedUser: item,
      showConfirmApprove: true,
      fullName: item?.name,
    });

    if (item?.store_location?.id) {
      this.setState({
        storeValue: [
          {
            label: item?.seller?.name + " - " + item?.store_location?.name,
            value: item?.store_location?.id,
          },
        ],
      });
    }
  };

  handleDelete = () => {
    this.setState({ loading: true });
    let url = `${config.backendServer}store_location/${this.state.selectedUser.store_location.id}/remove_staff/${this.state.selectedUser?.id}/`;
    // const isRedirect = utilityFunctions.getUserInfo()?.user?.id === this.state.selectedUser?.id;
    const token = utilityFunctions.getAccessToken();
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    fetch(url, options).then((response) => {
      this.setState({
        loading: false,
      });
      console.log(response.status);
      if (response.status === 204) {
        let tempUsers = this.state.data.filter(
          (x) => x.id !== this.state.data?.id,
        );
        this.setState({
          showConfirmDelete: false,
          loading: false,
          data: tempUsers,
        });
        // if (isRedirect) window.location.href = "/sellers";
        if (this.props.userInfo.user.role.includes("Commercial"))
          this.retrieveStaffs(this.props.userInfo.user.store_location_id);
        else this.retrieveEmployees({ pageNumber: 1, rowPerPage: 10 });
        this.props.setDefaultTab();
      } else if (response.status === 406) {
        alert(`Delete is not allowed, User is already linked to ticket`);
      } else if (response.status === 409) {
        alert(`User does not exist.`);
      } else if (!this.state.selectedUser.store_location?.id) {
        alert(`store location does not exist.`);
      } else {
        alert("Problem with system. Please refresh and try again later.");
      }
    });
  };

  retrieveStoreLocation = () => {
    this.setState({
      isLoading: true,
    });
    let params = {};

    if (this.props.selectedbrandID) {
      params.brand_id = this.props.selectedbrandID;
    }

    this.props
      .protectedFetch(
        config.backendServer + "store_location/dropdown/",
        "GET",
        params,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const options = res.map((r) => {
          return { label: r.combine_name, value: r.id };
        });

        this.setState({
          sellers: res,
          filteredSellers: res,
          isLoading: false,
          locationOptions: [...[{ label: "--", value: "" }], ...options],
          selectedSeller: options.find((s) => s.value === res[0].id),
        });
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
        });
        console.log(err);
      });
  };

  retrieveEmployees = ({ urlTxt, rowPerPage, pageNumber, q } = {}) => {
    this.setState({ loading: true });

    const { isCin7, isApproval, protectedFetch } = this.props;
    const { rowPerPage: rowPage, pageNumber: statePage } = this.state;

    let baseUrl = config.backendServer + "employee/";
    let queryParams = new URLSearchParams();

    if (urlTxt) {
      baseUrl = urlTxt.replace(/\?$/, "");
    } else {
      if (isCin7) {
        queryParams.append("cin7_access", "all,partial");
      } else if (isApproval) {
        queryParams.append("status", "requested");
      } else {
        queryParams.append("roles", "Commercial Staff,Commercial Admin");
        queryParams.append("status", "active");
      }

      queryParams.append("limit", rowPerPage || rowPage || 10);
      queryParams.append("page", pageNumber || statePage || 1);
      queryParams.append("pagination", "true");

      if (q) {
        queryParams.append("q", q);
      }

      if (this.props.selectedbrandID) {
        queryParams.append("brand_id", this.props.selectedbrandID);
      }

      baseUrl = `${baseUrl}?${queryParams.toString()}`;
    }

    protectedFetch(baseUrl, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          loading: false,
          data: res?.results,
          filteredStaffs: res?.results,
          totalEmployee: res?.count,
          nextPageEmploy: res?.next,
          prevPageEmploy: res?.previous,
          rowPerPage: rowPerPage || rowPage || 10,
          pageNumber: pageNumber ?? statePage ?? 1,
        });
      })
      .catch(() => {
        console.error("Failed to fetch employees");
        this.setState({ loading: false });
      });
  };

  handleChangePage = (event, newPage) => {
    let apiUrl = "";
    if (event.currentTarget.title === "Next page")
      apiUrl = this.state.nextPageEmploy;
    else apiUrl = this.state.prevPageEmploy;

    const pageNumber = newPage + 1;

    this.setState({
      pageNumber,
    });

    if (this.isCommercialUser()) {
      this.retrieveStaffs(this.props.userInfo.user.store_location_id, {
        pageNumber,
      });
    } else
      this.retrieveEmployees({
        urlTxt: apiUrl,
        pageNumber,
        rowPerPage: this.state.rowPerPage,
      });
  };

  handleChangeRowsPerPage = (event) => {
    const rowPerPage = parseInt(event.target.value, 10);
    this.setState({
      rowPerPage,
      pageNumber: 1,
    });
    if (this.isCommercialUser()) {
      this.retrieveStaffs(this.props.userInfo.user.store_location_id, {
        pageSize: rowPerPage,
        pageNumber: 1,
      });
    } else this.retrieveEmployees({ rowPerPage: rowPerPage, pageNumber: 1 });
  };

  retrieveStaffs = (id, { pageSize, pageNumber, q } = {}) => {
    this.setState({ loading: true, storeLocationId: id });
    let url = "";

    if (this.state.page?.next) url = this.state.page.next;
    else if (this.state.page?.previous) url = this.state.page.next;
    else if (id)
      url = config.backendServer + `store_location/${id}/commercial_staff/`;

    let params = {
      page: pageNumber || 1,
      page_size: pageSize || 10,
    };

    if (q) {
      params.q = q;
    }

    this.props
      .protectedFetch(url, "GET", params, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          loading: false,
          data: res.results,
          filteredStaffs: res.results,
          totalEmployee: res?.count,
          pageNumber: pageNumber || 1,
          rowPerPage: pageSize || 10,
        });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search);
    const searchFromUrl = searchParams.get("search") || "";

    this.setState({ searchFilter: searchFromUrl });

    if (this.isCommercialUser())
      this.retrieveStaffs(this.props.userInfo.user.store_location_id, {
        q: searchFromUrl,
      });
    else
      this.retrieveEmployees({
        rowPerPage: 10,
        pageNumber: 1,
        q: searchFromUrl,
      });
  }

  componentDidUpdate(prevProps) {
    // Check if selectedbrandID has changed
    if (prevProps.selectedbrandID !== this.props.selectedbrandID) {
      this.setState(
        {
          pageNumber: 1,
          searchFilter: "",
          filteredStaffs: [],
          data: [],
        },
        () => {
          if (this.isCommercialUser()) {
            this.retrieveStaffs(this.props.userInfo.user.store_location_id, {
              pageNumber: 1,
              pageSize: 10,
            });
          } else {
            this.retrieveStoreLocation();
            this.retrieveEmployees({ rowPerPage: 10, pageNumber: 1 });
          }
        },
      );
    }
  }

  handleAddUserCommercial = (userId, storeLocationId) => {
    this.setState({ loading: true });
    if (!userId && !this.state.storeLocationId) {
      alert("User is not selected");
      return;
    }
    let payload = {
      employee_id: userId,
    };
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axios
      .post(
        `${config.backendServer}store_location/${
          this.state.storeLocationId || storeLocationId
        }/add_staff/`,
        payload,
        options,
      )
      .then(() => {
        this.setState({
          loading: false,
          showAddUser: false,
          employeeID: "",
        });
        if (this.props.userInfo.user.role.includes("Commercial"))
          this.retrieveStaffs(this.props.userInfo.user.store_location_id);
        else
          this.retrieveEmployees({
            rowPerPage: this.state.rowPerPage,
            pageNumber: this.state.pageNumber,
          });
        this.props.setDefaultTab();
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("service user failed");
      });
  };

  handleResetPassword = (password) => {
    this.setState({ loading: true });
    if (!this.state.selectedUser) {
      alert("User is not selected");
      return;
    }
    let payload = {
      password: password,
    };
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axios
      .put(
        `${config.backendServer}employee/${this.state.selectedUser.id}/change_password/`,
        payload,
        options,
      )
      .then((res) => {
        console.log(res);
        alert("Password is changed");
        let tempUsers = [...this.state.data];
        tempUsers.push(res.data);
        this.setState({ loading: false, showResetPwd: false, data: tempUsers });
        this.retrieveStaffs(this.props.userInfo.user.store_location_id);
        this.props.setDefaultTab();

        // console.log("service user");
        // this.props.setCurrentTab;
        //   resolve(res);
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("service user failed");
        //   resolve(err);
      });
  };
  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  onKeyDown = (e) => {
    if (e.key === "Enter") {
      this.onPressSearch();
    }
  };

  onPressSearch = () => {
    const searchFilter = this.state.searchFilter;

    // Update URL with search parameter
    const searchParams = new URLSearchParams(this.props.location.search);
    if (searchFilter) {
      searchParams.set("search", searchFilter);
    } else {
      searchParams.delete("search");
    }

    this.props.history.push({
      pathname: this.props.location.pathname,
      search: searchParams.toString(),
    });

    this.setState(
      {
        pageNumber: 1,
      },
      () => {
        if (this.isCommercialUser()) {
          this.retrieveStaffs(this.props.userInfo.user.store_location_id, {
            q: searchFilter,
            pageNumber: 1,
          });
        } else {
          this.retrieveEmployees({
            q: searchFilter,
            pageNumber: 1,
            rowPerPage: this.state.rowPerPage,
          });
        }
      },
    );
  };

  handleRowClick = (item) => {
    if (!this.props.isCin7 && !this.props.isApproval) {
      if (["Admin", "Staff", "Commercial Admin"].includes(this.props.role))
        this.setState({ showStaffEdit: true, selectedUser: item });
    }
  };

  // handleSelectSeller = (seller) => {
  //   const opt = this.state.sellers
  //     .find((sel) => sel.id === seller)
  //     ?.store_locations.map((s) => {
  //       return { value: s.id, label: s.name };
  //     });
  //   const locationOptions = [...[{ label: "All", value: "" }], ...opt];
  //   this.setState({ locationOptions });
  // };

  handleSubmitApprove = (obj) => {
    this.setState({ loading: true });

    const id = this.state.selectedUser?.id;
    let payload = {
      name: obj.name,
      status: "active",
      store_location: obj.store_location,
      cin7_access: obj.cin7_access,
    };

    this.props
      .protectedFetch(
        config.backendServer + `employee/${id}/`,
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.setState({
          loading: false,
          showConfirmApprove: false,
        });
        alert("Approve Success");
        this.retrieveEmployees({ rowPerPage: 10, pageNumber: 1 });
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("fail");
        alert("Failed");
      });
  };

  handleSubmitDecline = () => {
    this.setState({ loading: true });

    const id = this.state.selectedUser?.id;
    let payload = {
      status: "declined",
    };

    this.props
      .protectedFetch(
        config.backendServer + `employee/${id}/`,
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.setState({
          loading: false,
        });
        alert("Decline Success");
        this.retrieveEmployees({ rowPerPage: 10, pageNumber: 1 });
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("fail");
        alert("Failed");
      });

    this.setState({ showConfirmDecline: false });
  };

  handleSubmitCin7Access = (obj) => {
    this.setState({ loading: true });

    const id = this.state.selectedUser?.id;
    let payload = {
      name: obj.name,
      store_location: obj.store_location,
      cin7_access: obj.cin7_access,
    };

    this.props
      .protectedFetch(
        config.backendServer + `employee/${id}/`,
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.setState({
          loading: false,
        });
        alert("Update Cin7 Success");
        this.retrieveEmployees({ rowPerPage: 10, pageNumber: 1 });
        this.setState({ showCin7Modal: false });
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("fail");
        alert("Failed");
        this.setState({ showCin7Modal: false });
      });
  };

  handleToggleEmailNotification = (item) => {
    const newValue = !item.receive_email;
    this.props
      .protectedFetch(
        apiEndpoints.employee.update(item.id),
        "PATCH",
        { receive_email: newValue },
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.setState((prev) => ({
          data: prev.data.map((emp) =>
            emp.id === item.id ? { ...emp, receive_email: newValue } : emp,
          ),
          filteredStaffs: prev.filteredStaffs.map((emp) =>
            emp.id === item.id ? { ...emp, receive_email: newValue } : emp,
          ),
        }));
      })
      .catch(() => {
        console.log("fail");
      });
  };

  handleVerifyAccount = () => {
    // this.setState({ loading: true });

    if (!this.state.selectedUser) {
      alert("User is not selected");
      this.setState({ loading: false });
      return;
    }

    const payload = {
      employee_id: this.state.selectedUser.id,
      email: this.state.selectedUser.email,
    };

    this.props
      .protectedFetch(
        config.backendServer + "employee/verify/",
        "POST",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        alert(res?.message ?? "Verification email has been success");
        this.setState({
          loading: false,
          showVerifyAccount: false,
          selectedUser: null,
        });
      })
      .catch((error) => {
        console.error(error);
        alert("Failed to verification email");
        this.setState({ loading: false });
      });
  };

  render() {
    // if (!this.state.loading && !this.state.data.length)
    //   return (
    //     <div>
    //       <span>No data available</span>
    //     </div>
    //   );
    const selectedUsersTemp = this.state.data?.map((x) => {
      return x.employee;
    });
    const optionEmployees = this.props.employees
      ?.filter((x) => !selectedUsersTemp?.includes(x.id))
      .map((val) => {
        return {
          value: parseInt(val.id),
          label: `${val.name} - ${val.user_role}`,
        };
      });
    const selectedAssignTo = optionEmployees?.find(
      (x) => x.value === this.state.employeeID,
    );
    return (
      <div>
        <div className="row">
          <div className="d-flex justify-content-end gap-2 mb-3">
            <div className="input-group col-3 pr-0">
              <input
                type="text"
                placeholder="Search..."
                id={"searchFilter"}
                className={"form-control"}
                onChange={this.handleChange}
                onKeyDown={this.onKeyDown}
                value={this.state.searchFilter}
                // width={"100rem"}
              />
              <div
                className="input-group-prepend cursor-pointer"
                onClick={this.onPressSearch}
              >
                <span className="form-control ">
                  <i className="fa fa-search form-control-icon"></i>
                </span>
              </div>
            </div>
            {!this.props.isCin7 &&
            !this.props.isApproval &&
            !this.props.isUserCommercial ? (
              <button
                title="Add Commercial Staff"
                className="k-btn k-btn-primary k-btn-sm"
                onClick={() => {
                  this.setState({ showStaffAdd: true, selectedUser: null });
                }}
              >
                Add Commercial Staff
              </button>
            ) : null}
          </div>
          <div className="d-flex justify-content-end"></div>
        </div>

        {/* {["Admin", "Staff", "Commercial Admin"].includes(this.props.role) && (
          <div className="d-flex justify-content-end mb-2">
            <button type="button" className="btn btn-outline-primary btn-sm col-2 mr-2" onClick={() => this.setState({ showAddUser: true })}>
              Add existing user
            </button>
            <button
              type="button"
              className="btn btn-outline-primary btn-sm col-2"
              onClick={() => this.setState({ showStaffAdd: true, selectedUser: null })}
            >
              Create new user
            </button>
          </div>
        )} */}

        <TableContainer
          sx={{
            maxHeight: 600,
            overflowX: "auto",
            overflowY: "auto",
            border: "1px solid lightgray",
          }}
        >
          <Table
            aria-labelledby="tableTitle"
            size="small"
            aria-label="enhanced table"
            sx={{ minWidth: 800 }}
          >
            <TableHeaders
              isCin7={this.props.isCin7}
              isApproval={this.props.isApproval}
              isCommercial={this.props.isCommercial}
            />

            {this.state.loading && <LoadingPage />}

            <TableBody>
              {this.state.filteredStaffs.length > 0 ? (
                this.state.filteredStaffs
                  ?.sort((a, b) => b.id - a.id)
                  ?.map((item, i) => (
                    <StaffRow
                      key={item.id || i}
                      item={item}
                      isCin7={this.props.isCin7}
                      isApproval={this.props.isApproval}
                      isCommercial={this.props.isCommercial}
                      role={this.props.role}
                      onNameClick={(item) =>
                        this.setState({
                          showCin7Modal: true,
                          selectedUser: item,
                        })
                      }
                      onRowClick={(item) => this.handleRowClick(item)}
                      onResetPassword={(item) =>
                        this.setState({
                          showResetPwd: true,
                          selectedUser: item,
                        })
                      }
                      onDelete={(item) => this.handleClickDelete(item)}
                      onApprove={(item) => this.handleClickApprove(item)}
                      onDecline={(item) => this.handleClickDecline(item)}
                      onToggleEmailNotif={(item) =>
                        this.handleToggleEmailNotification(item)
                      }
                      onVerifyAccount={(item) =>
                        this.setState({
                          showVerifyAccount: true,
                          selectedUser: item,
                        })
                      }
                    />
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 25, 100]}
          component="div"
          count={this.state.totalEmployee || 0}
          rowsPerPage={this.state.rowPerPage}
          page={this.state.pageNumber - 1}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
        />

        <Modal
          isOpen={this.state.showAddUser}
          //onRequestClose={()=>this.setState({showDeclineModal: false})}
          contentLabel={"Add Note"}
          className={"input-modal"}
        >
          <div className="card">
            <button
              onClick={() => this.setState({ showAddUser: false })}
              className={"confirm-modal-close"}
            >
              <MdClose />
            </button>
            <div className="card-header">
              {this.state.editedNote ? "Edit" : "Add"} Staff
            </div>
            <form>
              <div className={"card-body"}>
                <Select
                  data-testid="assign-to-select"
                  defaultValue={selectedAssignTo}
                  isSearchable={true}
                  options={optionEmployees}
                  // onInputChange={(val) => this.handleSearchServiceCenter(val)}
                  onChange={(obj) => {
                    this.setState({ employeeID: obj.value });
                    // this.handleSearchServiceCenter(obj);
                  }}
                />
              </div>
              <div className={"card-footer"}>
                <button
                  type="button"
                  className={"btn btn-outline-primary mr-3"}
                  onClick={() =>
                    this.handleAddUserCommercial(this.state.employeeID)
                  }
                >
                  Save
                </button>
                <button
                  type={"button"}
                  className={"btn btn-outline-secondary"}
                  onClick={() =>
                    this.setState({ showAddUser: false, addedNote: "" })
                  }
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.showConfirmDelete}
          contentLabel={"Reset Password"}
          className={"input-modal-small"}
        >
          <div className="card">
            <button
              onClick={() => this.setState({ showConfirmDelete: false })}
              className={"confirm-modal-close"}
            >
              <MdClose />
            </button>
            <div className="card-header">
              <h6>Remove Confirmation</h6>
            </div>
            <form>
              <div className="card-body text-center">
                <div className="mb-3">
                  Remove store location user {this.state.selectedUser?.name}?
                </div>
              </div>
              <div className="card-footer">
                <div className="row ">
                  <div className="col-6 text-right ">
                    <button
                      type="button"
                      className={"btn btn-outline-danger"}
                      onClick={() => {
                        this.handleDelete();
                        // if (this.state.modalCaption.toLowerCase().includes("reset")) this.handleResetPassword();
                        // else this.handleSendVerification(event);
                        // this.setState({ showModalResetPassword: false });
                      }}
                    >
                      Remove
                    </button>
                  </div>
                  <div className="col-6 text-left">
                    <button
                      type={"button"}
                      className={"btn btn-outline-secondary"}
                      onClick={() =>
                        this.setState({ showConfirmDelete: false })
                      }
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.showStaffAdd}
          contentLabel={"Add Staff"}
          className={"input-modal"}
        >
          <StaffAdd
            user={this.state.selectedUser}
            protectedFetch={this.props.protectedFetch}
            closeModal={() => this.setState({ showStaffAdd: false })}
            addExistingUser={(userId, storeLocationId) =>
              this.handleAddUserCommercial(userId, storeLocationId)
            }
            retrieveStaffs={() =>
              this.props.userInfo.user?.store_location_id
                ? this.retrieveStaffs(
                    this.props.userInfo.user.store_location_id,
                  )
                : this.retrieveEmployees()
            }
            isInsertCin7={true}
          />
        </Modal>
        <Modal
          isOpen={this.state.showStaffEdit}
          contentLabel={"Edit Staff"}
          className={"input-modal"}
        >
          <StaffEdit
            user={this.state.selectedUser}
            protectedFetch={this.props.protectedFetch}
            closeModal={() => this.setState({ showStaffEdit: false })}
            retrieveStaffs={() =>
              this.props.userInfo.user?.store_location_id
                ? this.retrieveStaffs(
                    this.props.userInfo.user.store_location_id,
                  )
                : this.retrieveEmployees()
            }
            isInsertCin7={true}
            // addExistingUser={(id) => this.handleAddUserCommercial(id)}
          />
        </Modal>

        <ModalResetPassword
          isOpen={this.state.showResetPwd}
          onClose={() => this.setState({ showResetPwd: false })}
          onSubmit={(password) => {
            this.handleResetPassword(password);
          }}
          isLoading={this.state.loading}
        />

        <ModalApprove
          isOpen={this.state.showConfirmApprove}
          onClose={() => this.setState({ showConfirmApprove: false })}
          contentLabel={"Approve Account"}
          email={this.state?.selectedUser?.email || ""}
          locationOptions={this.state.locationOptions}
          isLoading={this.state.isLoading}
          onSubmit={this.handleSubmitApprove}
          selectedUser={this.state.selectedUser}
          protectedFetch={this.props.protectedFetch}
        />

        <ModalCin7
          isOpen={this.state.showCin7Modal}
          onClose={() => this.setState({ showCin7Modal: false })}
          contentLabel={"Cin7 Integration"}
          email={this.state?.selectedUser?.email || ""}
          locationOptions={this.state.locationOptions}
          isLoading={this.state.isLoading}
          onSubmit={this.handleSubmitCin7Access}
          selectedUser={this.state.selectedUser}
          protectedFetch={this.props.protectedFetch}
        />

        <ModalDecline
          isOpen={this.state.showConfirmDecline}
          onClose={() => this.setState({ showConfirmDecline: false })}
          onSubmit={this.handleSubmitDecline}
          userName={this.state.selectedUser?.name || ""}
          isLoading={this.state.loading}
        />

        <ModalVerifyAccount
          isOpen={this.state.showVerifyAccount}
          onClose={() => this.setState({ showVerifyAccount: false })}
          onSubmit={this.handleVerifyAccount}
          userName={this.state.selectedUser?.name || ""}
          userEmail={this.state.selectedUser?.email || ""}
          isLoading={this.state.loading}
        />
      </div>
    );
  }
}

export default withRouter(Staffs);

const accessLevelOptions = [
  { label: "No Access", value: "no_access" },
  { label: "Access", value: "partial" },
];

const ModalApprove = ({
  isOpen,
  onClose,
  contentLabel,
  email,
  onSubmit,
  selectedUser,
}) => {
  const [formData, setFormData] = useState({
    fullName: "",
    storeValue: null,
    accessLevel: null,
    note: "",
  });

  useEffect(() => {
    if (selectedUser && isOpen) {
      setFormData({
        fullName: selectedUser.name || "",
        storeValue: selectedUser.store_location?.id
          ? {
              label: `${selectedUser.seller?.name || ""} - ${
                selectedUser.store_location?.name || ""
              }`,
              value: selectedUser.store_location.id,
            }
          : null,
        accessLevel: selectedUser.cin7_access
          ? {
              label:
                selectedUser.cin7_access === "no_access"
                  ? "No Access"
                  : "Access",
              value: selectedUser.cin7_access,
            }
          : { label: "No Access", value: "no_access" },
        note: selectedUser.commercial_location_notes || "",
      });
    }
  }, [selectedUser, isOpen]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.storeValue?.value) {
      return;
    }

    if (onSubmit) {
      onSubmit({
        name: formData.fullName,
        store_location: formData.storeValue?.value,
        cin7_access: formData.accessLevel?.value,
      });
    }
  };

  const handleClose = () => {
    setFormData({
      fullName: "",
      storeValue: null,
      cin7Name: "",
      accessLevel: null,
      note: "",
    });
    onClose();
  };

  const isFormValid =
    formData.accessLevel !== null && formData.storeValue !== null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel={contentLabel}
      className={"input-modal"}
    >
      <div className="card">
        <button onClick={handleClose} className={"confirm-modal-close"}>
          <MdClose />
        </button>
        <div className="card-header">
          <h6>Approve Confirmation</h6>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={"card"} style={{ height: "100%" }}>
            <div className="card-body">
              <div className={"single-warranty-details-item"}>
                <label className={"single-warranty-details-label"}>
                  Email: {email || ""}
                </label>
              </div>

              <div className={"single-warranty-details-item"}>
                <label className={"single-warranty-details-label required"}>
                  Full name:
                </label>
                <input
                  type="text"
                  id="name"
                  required={true}
                  value={formData.fullName}
                  className="form-control"
                  onChange={(e) =>
                    handleInputChange("fullName", e.target.value)
                  }
                />
              </div>

              <div className={"single-warranty-details-item"}>
                <label className={"single-warranty-details-label required"}>
                  CIN7 Access:
                </label>
                <Select
                  id={"accessLevel"}
                  data-testid="access-level-select"
                  value={formData.accessLevel}
                  options={accessLevelOptions}
                  onChange={(obj) => handleInputChange("accessLevel", obj)}
                  placeholder="Select access level..."
                />
              </div>

              <div className="form-input">
                <label className="required">Store Location</label>
                <SelectOption
                  id={"storeLocation"}
                  data-testid="assign-to-select"
                  value={formData.storeValue}
                  apiEndpoint={
                    config.backendServer + "store_location/dropdown/"
                  }
                  onChange={(obj) => handleInputChange("storeValue", obj)}
                  placeholder="Select store location..."
                  additionalParams={{
                    brand_id: utilityFunctions.getCookie("brandId") || "",
                  }}
                  formatLabel={(item) => item.combine_name}
                />
                {!formData.storeValue && (
                  <small className="text-danger">
                    *Store location is required
                  </small>
                )}
              </div>

              <div className={"single-warranty-details-item"}>
                <label className={"single-warranty-details-label"}>
                  Note: {formData.note}
                </label>
              </div>
            </div>
          </div>

          <div className="card-footer">
            <div className="row ">
              <div className="col-3 text-right ">
                <button
                  type="submit"
                  className={"btn btn-outline-primary"}
                  disabled={!isFormValid}
                >
                  Approve
                </button>
              </div>
              <div className="col-3 text-left">
                <button
                  type={"button"}
                  className={"btn btn-outline-secondary"}
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

const ModalCin7 = ({
  isOpen,
  onClose,
  contentLabel,
  email,
  onSubmit,
  selectedUser,
}) => {
  const [formData, setFormData] = useState({
    fullName: "",
    storeValue: null,
    accessLevel: null,
  });

  useEffect(() => {
    if (selectedUser && isOpen) {
      setFormData({
        fullName: selectedUser.name || "",
        storeValue: selectedUser.store_location?.id
          ? {
              label: `${selectedUser.seller?.name || ""} - ${
                selectedUser.store_location?.name || ""
              }`,
              value: selectedUser.store_location.id,
            }
          : null,
        accessLevel: selectedUser.cin7_access
          ? {
              label:
                selectedUser.cin7_access === "no_access"
                  ? "No Access"
                  : "Access",
              value: selectedUser.cin7_access,
            }
          : null,
      });
    }
  }, [selectedUser, isOpen]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit({
        name: formData.fullName,
        store_location: formData.storeValue?.value,
        cin7_access: formData.accessLevel?.value,
      });
    }
  };

  const handleClose = () => {
    setFormData({
      fullName: "",
      storeValue: null,
      accessLevel: null,
    });
    onClose();
  };

  const isFormValid =
    formData.accessLevel !== null && formData.storeValue !== null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel={contentLabel}
      className={"input-modal"}
    >
      <div className="card">
        <button onClick={handleClose} className={"confirm-modal-close"}>
          <MdClose />
        </button>
        <div className="card-header">
          <h6>CIN7 Access</h6>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={"card"} style={{ height: "100%" }}>
            <div className="card-body">
              <div className={"single-warranty-details-item"}>
                <label className={"single-warranty-details-label"}>
                  Email: {email || ""}
                </label>
              </div>

              <div className={"single-warranty-details-item"}>
                <label className={"single-warranty-details-label required"}>
                  Name:
                </label>
                <input
                  type="text"
                  id="name"
                  required={true}
                  value={formData.fullName}
                  className="form-control"
                  onChange={(e) =>
                    handleInputChange("fullName", e.target.value)
                  }
                />
              </div>

              <div className={"single-warranty-details-item"}>
                <label className={"single-warranty-details-label required"}>
                  CIN7 Access:
                </label>
                <Select
                  id={"accessLevel"}
                  data-testid="access-level-select"
                  value={formData.accessLevel}
                  options={accessLevelOptions}
                  onChange={(obj) => handleInputChange("accessLevel", obj)}
                  placeholder="Select access level..."
                />
              </div>

              <div className="form-input">
                <label className="required">Store Location</label>
                <SelectOption
                  id={"storeLocation"}
                  data-testid="store-location-select"
                  value={formData.storeValue}
                  apiEndpoint={
                    config.backendServer + "store_location/dropdown/"
                  }
                  onChange={(obj) => handleInputChange("storeValue", obj)}
                  placeholder="Select store location..."
                  isDisabled={false}
                  additionalParams={{
                    brand_id: utilityFunctions.getCookie("brandId") || "",
                  }}
                  formatLabel={(item) => item.combine_name}
                />
                {!formData.storeValue && (
                  <small className="text-danger">
                    *Store location is required
                  </small>
                )}
              </div>
            </div>
          </div>

          <div className="card-footer">
            <div className="row">
              <div className="col-6 text-right">
                <button
                  type="submit"
                  className={"btn btn-outline-primary"}
                  disabled={!isFormValid}
                >
                  Submit
                </button>
              </div>
              <div className="col-6 text-left">
                <button
                  type={"button"}
                  className={"btn btn-outline-secondary"}
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

const ModalResetPassword = ({ isOpen, onClose, onSubmit, isLoading }) => {
  const [formData, setFormData] = React.useState({
    password1: "",
    password2: "",
    typePassword: true,
    errorPassword: false,
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    // Clear error when user starts typing
    if (formData.errorPassword) {
      setFormData((prev) => ({ ...prev, errorPassword: false }));
    }
  };

  const togglePasswordVisibility = () => {
    setFormData((prev) => ({ ...prev, typePassword: !prev.typePassword }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.password1 !== formData.password2) {
      setFormData((prev) => ({ ...prev, errorPassword: true }));
      return;
    }

    if (onSubmit) {
      onSubmit(formData.password1);
    }
  };

  const handleClose = () => {
    setFormData({
      password1: "",
      password2: "",
      typePassword: true,
      errorPassword: false,
    });
    onClose();
  };

  const isFormValid =
    formData.password1 === formData.password2 && formData.password1;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel={"Reset Password"}
      className={"input-modal"}
    >
      <div className="card">
        <button onClick={handleClose} className={"confirm-modal-close"}>
          <MdClose />
        </button>
        <div className="card-header">
          <h6>Reset Password Confirmation</h6>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="card-body text-start">
            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Password{" "}
                <i
                  className={
                    formData.typePassword
                      ? "password-show fa fa-eye"
                      : "password-show fa fa-eye-slash"
                  }
                  aria-hidden="true"
                  onClick={togglePasswordVisibility}
                  style={{ cursor: "pointer" }}
                ></i>
                <span>:</span>
              </label>
              <input
                type={formData.typePassword ? "password" : "text"}
                id="password1"
                required={true}
                value={formData.password1}
                className="form-control"
                onChange={(e) => handleInputChange("password1", e.target.value)}
                disabled={isLoading}
              />
              {formData.errorPassword && (
                <span className="error-text">Password did not match</span>
              )}
            </div>
            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Confirm Password <span>:</span>
              </label>
              <input
                type={formData.typePassword ? "password" : "text"}
                id="password2"
                required={true}
                value={formData.password2}
                className="form-control"
                onChange={(e) => handleInputChange("password2", e.target.value)}
                disabled={isLoading}
              />
              {formData.errorPassword && (
                <span className="error-text">Password did not match</span>
              )}
            </div>
          </div>
          <div className="card-footer">
            <div className="row">
              <div className="col-6 text-right">
                <button
                  type="submit"
                  className={"btn btn-outline-info"}
                  disabled={!isFormValid || isLoading}
                >
                  {isLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
              <div className="col-6 text-left">
                <button
                  type={"button"}
                  className={"btn btn-outline-secondary"}
                  onClick={handleClose}
                  disabled={isLoading}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

const TableHeaders = ({ isCin7, isApproval, isCommercial }) => {
  const headerStyle = {
    fontSize: "12px",
    color: "#777777",
  };

  const HeaderCell = ({ className, children }) => (
    <TableCell style={headerStyle} className={className}>
      {children}
    </TableCell>
  );

  return (
    <TableHead>
      <TableRow>
        <HeaderCell className="col-1">Name</HeaderCell>
        <HeaderCell className="col-2">Email</HeaderCell>
        <HeaderCell className="col-1">Role</HeaderCell>
        <HeaderCell className="col-1">Ticket Numbers</HeaderCell>

        {!isCin7 && !isApproval && (
          <HeaderCell className="col-1">Store Location</HeaderCell>
        )}

        {isApproval && <HeaderCell className="col-1">Note</HeaderCell>}

        {isCommercial && <HeaderCell className="col-2">Approved By</HeaderCell>}

        {isCommercial && <HeaderCell className="col-1">Status</HeaderCell>}

        {!isCin7 && <HeaderCell className="col-4"></HeaderCell>}
      </TableRow>
    </TableHead>
  );
};

const ActionButtons = ({
  item,
  role,
  isApproval,
  // isCommercial,
  onResetPassword,
  onDelete,
  onApprove,
  onDecline,
  onToggleEmailNotif,
}) => {
  const isAuthorized = ["Admin", "Staff", "Commercial Admin"].includes(role);

  if (!isAuthorized) return null;

  if (isApproval) {
    return (
      <div className="row mr-3">
        <button
          className="col btn btn-outline-danger btn-sm mx-2"
          onClick={() => onDecline(item)}
        >
          Decline
        </button>
        <button
          className="col btn btn-outline-success btn-sm mx-2"
          onClick={() => onApprove(item)}
        >
          Approve
        </button>
      </div>
    );
  }

  return (
    <div className="row gap-2 mr-3">
      <button
        className=" btn btn-outline-info btn-sm mx-2"
        onClick={() => onResetPassword(item)}
      >
        Reset Password
      </button>
      <button
        className=" btn btn-sm btn-outline-danger mx-2"
        onClick={() => onDelete(item)}
      >
        Remove Store Location
      </button>
      <button
        className={`btn btn-sm mx-2 ${item.receive_email ? "btn-success" : "btn-outline-secondary"}`}
        title={
          item.receive_email
            ? "Email notification ON — click to disable"
            : "Email notification OFF — click to enable"
        }
        onClick={() => onToggleEmailNotif(item)}
      >
        {item.receive_email ? "Email Notif: ON" : "Email Notif: OFF"}
      </button>
    </div>
  );
};

const StaffRow = ({
  item,
  isCin7,
  isApproval,
  isCommercial,
  role,
  onNameClick,
  onRowClick,
  onResetPassword,
  onDelete,
  onApprove,
  onDecline,
  onVerifyAccount,
  onToggleEmailNotif,
}) => {
  const handleNameClick = () => {
    if (!isCin7 && !isApproval) {
      onRowClick(item);
    }
    if (isCin7) {
      onNameClick(item);
    }
  };

  const handleCellClick = () => {
    if (!isCin7 && !isApproval) {
      onRowClick(item);
    }
  };

  return (
    <TableRow className="list-group-item">
      <TableCell
        className="col-2"
        onClick={handleNameClick}
        sx={!isApproval ? { cursor: "pointer" } : {}}
      >
        {item?.name}
      </TableCell>

      <TableCell
        className="col-2"
        onClick={handleCellClick}
        sx={!isCin7 && !isApproval ? { cursor: "pointer" } : {}}
      >
        {item?.email}
      </TableCell>

      <TableCell>{item?.user_role}</TableCell>

      <TableCell className="col-1">
        <Link to={`/tickets?store_location=${item.store_location.id}`}>
          {item.ticket_count}
        </Link>
      </TableCell>

      {!isCin7 && !isApproval && (
        <TableCell className="col-1">
          {item?.store_location?.name || ""}
        </TableCell>
      )}

      {isApproval && (
        <TableCell>{item.commercial_location_notes || ""}</TableCell>
      )}

      {isCommercial && (
        <>
          <TableCell>
            {`${item?.approver_role || ""} ${
              item.approver_name ? `- ${item.approver_name}` : ""
            }`}
          </TableCell>
          <TableCell>
            {item.status === "need_verify" ? (
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => onVerifyAccount(item)}
              >
                Verify Account
              </button>
            ) : (
              <span className={item.status === "active" ? "active-status" : ""}>
                {item.status
                  ? item.status.charAt(0).toUpperCase() + item.status.slice(1)
                  : ""}
              </span>
            )}
          </TableCell>
        </>
      )}

      {!isCin7 && (
        <TableCell className="col-4" sx={{ minWidth: 100 }}>
          <ActionButtons
            item={item}
            role={role}
            isApproval={isApproval}
            isCommercial={isCommercial}
            onResetPassword={onResetPassword}
            onDelete={onDelete}
            onApprove={onApprove}
            onDecline={onDecline}
            onToggleEmailNotif={onToggleEmailNotif}
          />
        </TableCell>
      )}
    </TableRow>
  );
};

const ModalDecline = ({ isOpen, onClose, onSubmit, userName, isLoading }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={"Decline Confirmation"}
      className={"input-modal-small"}
    >
      <div className="card">
        <button onClick={onClose} className={"confirm-modal-close"}>
          <MdClose />
        </button>
        <div className="card-header">
          <h6>Decline Confirmation</h6>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="card-body text-center">
            <div className="mb-3">
              Are you sure you want to decline user <strong>{userName}</strong>?
            </div>
          </div>
          <div className="card-footer">
            <div className="row">
              <div className="col-6 text-right">
                <button
                  type="submit"
                  className={"btn btn-outline-danger"}
                  disabled={isLoading}
                >
                  {isLoading ? "Declining..." : "Decline"}
                </button>
              </div>
              <div className="col-6 text-left">
                <button
                  type={"button"}
                  className={"btn btn-outline-secondary"}
                  onClick={onClose}
                  disabled={isLoading}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

const ModalVerifyAccount = ({
  isOpen,
  onClose,
  onSubmit,
  userName,
  userEmail,
  isLoading,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={"Verify Account Confirmation"}
      className={"input-modal-small"}
    >
      <div className="card">
        <button onClick={onClose} className={"confirm-modal-close"}>
          <MdClose />
        </button>
        <div className="card-header">
          <h6>Verify Account Confirmation</h6>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="card-body text-center">
            <div
              className="mb-3"
              style={{ minWidth: "400px", maxWidth: "600px", margin: "0 auto" }}
            >
              Are you sure you want to verify account{" "}
              <strong>{userName}</strong> ({userEmail})?
            </div>
          </div>
          <div className="card-footer">
            <div className="row">
              <div className="col-6 text-right">
                <button
                  type="submit"
                  className={"btn btn-outline-primary"}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Verify"}
                </button>
              </div>
              <div className="col-6 text-left">
                <button
                  type={"button"}
                  className={"btn btn-outline-secondary"}
                  onClick={onClose}
                  disabled={isLoading}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};
